export default "__VITE_ASSET__DhQQMcAD__"